import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const changeTrialConsent = async ({ trialId, consentForm, consentTemplateId }) => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${__API_URL__}/api/photos/trials/${trialId}/consent/`,
    { consent_form: consentForm, consent_template_id: consentTemplateId },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

const useChangeTrialConsentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeTrialConsent,
    onSuccess: (_data, { trialId }) => {
      queryClient.invalidateQueries({ queryKey: ["trial-consent-impact", trialId] });
    },
  });
};

export default useChangeTrialConsentMutation;
